import { ClinicProduct } from '../../types';

const now = Date.now();
const inDays = (d: number) => new Date(now + d * 24 * 60 * 60 * 1000).toISOString();

export const MOCK_VIRTUAL_PRODUCTS: ClinicProduct[] = [
  {
    id: 'vp-001',
    nameEn: 'TCM Diagnostics Masterclass — On-demand',
    brand: 'VMall Academy',
    productType: 'VIRTUAL',
    category: 'OTHER',
    properties: ['Online course', '12 modules', 'CPD eligible'],
    unit: 'seat',
    spec: '12-module on-demand course',
    salePrice: 299,
    originalPrice: 399,
    gstRate: 0.1,
    stockStatus: 'IN_STOCK',
    availableStock: 60,
    moq: 1,
    imageUrl: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=800',
    virtualConfig: {
      format: 'ONLINE_COURSE',
      capacity: 100,
      reservedSlots: 8,
      soldSlots: 32,
      autoDelistAt: inDays(45),
      deliveryNotes:
        'Access link and credentials are emailed to the buyer within 1 minute of payment.',
    },
    infoSections: [
      {
        key: 'GENERAL',
        body: 'A 12-module on-demand programme covering pulse, tongue, and pattern differentiation, taught by senior practitioners.',
      },
      {
        key: 'DIRECTIONS',
        body: 'Access is delivered by email immediately after payment. Course remains available for 12 months from activation.',
      },
    ],
  },
  {
    id: 'vp-002',
    nameEn: 'Sydney Clinic-Day Workshop — May 2026',
    brand: 'VMall Academy',
    productType: 'VIRTUAL',
    category: 'OTHER',
    properties: ['Offline workshop', 'Sydney CBD', 'Lunch included'],
    unit: 'seat',
    spec: 'One-day in-person workshop',
    salePrice: 480,
    gstRate: 0.1,
    stockStatus: 'LOW_STOCK',
    availableStock: 6,
    moq: 1,
    imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800',
    virtualConfig: {
      format: 'OFFLINE_COURSE',
      capacity: 30,
      reservedSlots: 3,
      soldSlots: 21,
      autoDelistAt: inDays(14),
      courseStartAt: inDays(20),
      courseEndAt: inDays(20),
      deliveryNotes:
        'Venue and check-in details are emailed 48h before the workshop.',
    },
    infoSections: [
      {
        key: 'GENERAL',
        body: 'Hands-on clinic-day workshop covering case-led pattern differentiation and dispensary workflow.',
      },
    ],
  },
  {
    id: 'vp-003',
    nameEn: 'Practitioner CPD Bundle (Digital)',
    brand: 'VMall Academy',
    productType: 'VIRTUAL',
    category: 'OTHER',
    properties: ['Digital bundle', 'Lifetime access'],
    unit: 'bundle',
    spec: 'Reference library + assessment',
    salePrice: 159,
    gstRate: 0.1,
    stockStatus: 'IN_STOCK',
    availableStock: 200,
    moq: 1,
    imageUrl: 'https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=800',
    virtualConfig: {
      format: 'OTHER',
      capacity: 500,
      reservedSlots: 4,
      soldSlots: 296,
      deliveryNotes: 'Download link is emailed immediately after payment.',
    },
    infoSections: [
      {
        key: 'GENERAL',
        body: 'A practitioner-grade digital bundle: reference monographs, dispensary checklists, and a self-assessment.',
      },
    ],
  },
];
